exports = module.exports = require("../../../../node_modules/_css-loader@1.0.1@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".footer[data-v-50325237] {\n  border-top: 1px solid #ebeef5;\n}", ""]);

// exports
